module.exports = __webpack_public_path__ + "static/media/reports_image2.87f88dcd.webp";